.faq-type-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;

  &__header {
    text-align: center;
    width: 100%;
    max-width: $breakpoint-desktop;
    margin: 0 auto var(--spacing-4xl);

    @include desktop {
      margin-bottom: var(--spacing-5xl);
    }
  }

  &__footer {
    text-align: center;
    width: 100%;
    max-width: $breakpoint-desktop;
    margin: var(--spacing-4xl) auto 0;

    @include desktop {
      margin-top: var(--spacing-5xl);
    }
  }

  &--align-start {
    align-items: flex-start;

    .faq-type-2__header {
      text-align: start;
      margin-left: 0;
      margin-right: 0;
    }

    .faq-type-2__footer {
      text-align: start;
      margin-left: 0;
      margin-right: 0;
    }

    .faq-type-2__accordion {
      max-width: 100%;
    }
  }

  &__accordion {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    align-self: stretch;
    width: 100%;
    max-width: $breakpoint-desktop;
    margin: 0 auto;
    gap: var(--spacing-md);

    &--two-columns {
      max-width: 100%;
    }

    &--animated {
      .faq-type-2__item-content {
        transition: grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .faq-type-2__item-content-inner {
        transition: padding-top 0.35s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .faq-type-2__item-icon::before,
      .faq-type-2__item-icon::after {
        transition:
          transform 0.3s ease,
          opacity 0.25s ease;
      }
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    position: relative;
    border: var(--border-size-sm) solid var(--border-color-primary);
    padding: var(--spacing-lg);

    @include desktop {
      padding: var(--spacing-xl);
    }

    &:focus-within:has(*:focus-visible) {
      outline: var(--border-size-md) solid var(--color-brand-primary-light) !important;
      outline-offset: var(--border-size-md);
      border-radius: var(--radius-size-sm);
      z-index: 1;
    }

    &-header {
      width: 100%;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;

      &:focus {
        outline: none;
      }

      // Real <h3> for SEO; display:contents keeps the me-text title as the
      // effective flex child so the layout is unchanged.
      .faq-type-2__item-title-heading {
        display: contents;
      }

      .faq-type-2__item-title {
        @include text-line-clamp(2);

        overflow: hidden;
        font-size: map-get($font-sizes, md);
        line-height: map-get($line-heights, md);
        font-weight: map-get($font-weights, bold);

        @include desktop {
          font-size: map-get($font-sizes, lg);
          line-height: map-get($line-heights, lg);
        }
      }
    }

    // CSS icon: + (closed) → − (open)
    &-icon {
      position: relative;
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      color: var(--color-neutral-black);

      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 16px;
        height: 1.5px;
        background-color: currentcolor;
        top: 50%;
        left: 50%;
      }

      &::before {
        transform: translate(-50%, -50%) rotate(0deg);
      }

      &::after {
        transform: translate(-50%, -50%) rotate(90deg);
        opacity: 1;
      }
    }

    &-content {
      display: grid;
      grid-template-rows: 0fr;
      width: 100%;
      overflow: hidden;
    }

    &-content-inner {
      min-height: 0;
      overflow: hidden;
      font-size: map-get($font-sizes, md);
      line-height: map-get($line-heights, md);
      font-weight: map-get($font-weights, normal);
      padding-top: 0;

      > :last-child {
        margin-bottom: 0;
      }
    }

    &--open {
      // − state: vertical arm rotates to horizontal and fades out
      .faq-type-2__item-icon::after {
        transform: translate(-50%, -50%) rotate(0deg);
        opacity: 0;
      }

      .faq-type-2__item-content {
        grid-template-rows: 1fr;
      }

      .faq-type-2__item-content-inner {
        padding-top: var(--spacing-lg);

        @include desktop {
          padding-top: var(--spacing-xl);
        }
      }
    }
  }
}
